import { apiClient } from "helpers/api_helper";
import { API } from "../constant/po.stock";

export const getpoInwardAndInventory = async (data: any) => {
    try {
        const response = await apiClient.get(API.Get_PO_Product_Inward_And_Inventory, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getRejectedProducts = async (data: any) => {
    try {
        const response = await apiClient.get(API.Get_PO_Rejected_Products, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getAssignProducts = async (data: any) => {
    try {
        const response = await apiClient.get(API.Get_All_Assign_Product_Invoice, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getpoInwardAndInventoryById = async (data: any) => {
    try {
        const response = await apiClient.get(API.Get_PO_Product_By_Id, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getRawMaterialById = async (data: any) => {
    try {
        const response = await apiClient.get(API.Get_Row_Material_By_PO_Product_Id, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const updatePoInwardProduct = async (data: object) => {
    try {
        const response = await apiClient.post(API.Update_PO_Product_Inwards, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const assignToStore = async (data: object) => {
    try {
        const response = await apiClient.post(API.Assign_Product_To_Store, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const rejectProduct = async (data: object) => {
    try {
        const response = await apiClient.post(API.Reject_PO_Product, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};